// @flow

import * as React from "react";
import styled from "@emotion/styled";
import colors from "../../../Styles/colors";
import {fontSize} from "../../../Styles/text";
import mq, {breakpoints} from "../../../Styles/breakpoints";
import Ad from "../../../Ads/components/Ad";

let InterruptBar = styled('div')`
  position: sticky;
  left: 0;
  width: 100%;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  grid-column: 1 / 3;
  background-color: ${colors.coreColor3};
  z-index: 3;
  width: 100%;
  display: flex;
  margin-bottom: -1px;
  justify-content: center;
  align-items: center;
  tab-index: -1;
  
  ${mq.large(`
    -ms-grid-column: 1;
    -ms-grid-column-span: 5;
    grid-column: 1 / -1;
  `)};
  
  @media print {
    display: none;
  }
  
  .sponsored {
    text-transform: uppercase;
    text-align: center;
  }
`;

let BreakBar = styled('div')`
  position: sticky;
  left: 0;
  width: 100%;
  padding: 4px;
  background: ${colors.main};
  color: ${colors.coreColor2};
  text-transform: uppercase;
  font-weight: bold;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  grid-column: 1 / 3;
  text-align: center;
  z-index: 3;
  ${fontSize(4)};
  
  ${mq.large(`
    -ms-grid-column: 1;
    -ms-grid-column-span: 5;
    grid-column: 1 / -1;
  `)};
  
  @media print {
    display: none;
  }
`;

type Props = {|
  name: string,
  msRows: Map<string, number>
|}

export default React.memo<Props>(function Interrupt({name, msRows}: Props) {
  return <React.Fragment>
    <InterruptBar
      // $FlowFixMe - Calls to get here are guaranteed, assuming the invariants of getGrid hold
      style={{msGridRow: `${msRows.get(`interrupt-${name}`)}`, gridRow: `interrupt-${name}`}}
    ><Ad adUnit="tpt_schedule_break" adWidth="728" adHeight="90" sponsored sizeMapping={[{viewport: [0, 0], slot: [320, 50]},{viewport: [breakpoints.xlarge, 0], slot: [728, 90]}]} /></InterruptBar>
    <BreakBar
      // $FlowFixMe - Calls to get here are guaranteed, assuming the invariants of getGrid hold
      style={{msGridRow: `${msRows.get(`break-${name}`)}`, gridRow: `break-${name}`}}
    >
      {name}
    </BreakBar>
  </React.Fragment>;
})